import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';
import { ProtocolAnswerInDto } from 'shared/dtos/in/protocolAnswer';

export type ProtocolItemCommentSource = {
  comment?: string;
  complianceCheck?: { comment?: string };
};

export type ProtocolItemComplianceSource = ProtocolItemCommentSource & {
  answers?: ProtocolAnswerInDto[] | { type: AnswerType; selectedOption?: ComplianceAnswerOption }[];
  complianceCheck?: {
    comment?: string;
    result?: ComplianceAnswerOption;
    issues?: string[];
  };
};

export function complianceResultFromProtocolAnswers(
  answers: ProtocolItemComplianceSource['answers']
): ComplianceAnswerOption {
  const complianceAnswer = answers?.find(
    (answer) => answer.type === AnswerType.Compliance
  );

  if (
    complianceAnswer?.type === AnswerType.Compliance &&
    complianceAnswer.selectedOption !== undefined
  ) {
    return complianceAnswer.selectedOption;
  }

  return ComplianceAnswerOption.unset;
}

export function getProtocolItemEkComment(
  item: ProtocolItemCommentSource
): string {
  return item.comment ?? item.complianceCheck?.comment ?? '';
}

export function getComplianceResultFromProtocolItem(
  item: ProtocolItemComplianceSource
): ComplianceAnswerOption {
  const fromAnswers = complianceResultFromProtocolAnswers(item.answers);
  if (fromAnswers !== ComplianceAnswerOption.unset) {
    return fromAnswers;
  }

  return item.complianceCheck?.result ?? ComplianceAnswerOption.unset;
}
